import React from 'react';
import Chart from 'react-apexcharts';

const CustomTreemap = ({
  heatMap,
  clickHandler
}) => {
  const options = {
    chart: {
      id: 'treemap',
      events: {
        click: typeof clickHandler === 'function' ? clickHandler : null
      },
      toolbar: false,
      animations: {
        enabled: false,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: false,
          delay: 150
        },
        dynamicAnimation: {
          enabled: false,
          speed: 350
        }
      }
    },
    tooltip: {
      enabled: true,
      fillSeriesColor: false,
      followCursor: true,
      onDatasetHover: {
        highlightDataSeries: false
      }
    },
    states: {
      hover: {
        filter: {
          type: 'none'
        }
      }
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '12px'
      },
      formatter: function (text, op) {
        return [text[0], text[1], op.value];
      },
      offsetY: -4
    },
    plotOptions: {
      treemap: {
        dataLabels: {
          position: 'middle'
        },
        enableShades: false,
        shadeIntensity: 0,
        reverseNegativeShade: true,
        colorScale: {
          ranges: [{
            from: 0,
            to: 2.5,
            color: '#1BDC81'
          }, {
            from: 2.5,
            to: 5,
            color: '#19C976'
          }, {
            from: 5,
            to: 7.5,
            color: '#14AD66'
          }, {
            from: 7.5,
            to: 10,
            color: '#13A461'
          }, {
            from: 10,
            to: 12.5,
            color: '#119256'
          }, {
            from: 12.5,
            to: 15,
            color: '#0F804B'
          }, {
            from: 15,
            to: 17.5,
            color: '#0D6E40'
          }, {
            from: 17.5,
            to: 20,
            color: '#0A5C36'
          }, {
            from: 20,
            to: 22.5,
            color: '#084A2B'
          }, {
            from: 22.5,
            to: 25,
            color: '#063720'
          }, {
            from: 25,
            to: 27.5,
            color: '#B896ED'
          }, {
            from: 27.5,
            to: 30,
            color: '#A073E7'
          }, {
            from: 30,
            to: 32.5,
            color: '#9463E4'
          }, {
            from: 32.5,
            to: 35,
            color: '#8851E1'
          }, {
            from: 35,
            to: 37.5,
            color: '#7D40DE'
          }, {
            from: 37.5,
            to: 40,
            color: '#702EDD'
          }, {
            from: 40,
            to: 42.5,
            color: '#6623D1'
          }, {
            from: 42.5,
            to: 45,
            color: '#551EAE'
          }, {
            from: 45,
            to: 47.5,
            color: '#4D1B9E'
          }, {
            from: 47.5,
            to: 50.5,
            color: '#44188C'
          }, {
            from: 50.5,
            to: 52.5,
            color: '#7A8FF5'
          }, {
            from: 52.5,
            to: 55,
            color: '#687FF4'
          }, {
            from: 55,
            to: 57.5,
            color: '#4966F2'
          }, {
            from: 57.5,
            to: 60,
            color: '#2F4FEF'
          }, {
            from: 60,
            to: 62.5,
            color: '#1B3FEE'
          }, {
            from: 62.5,
            to: 65,
            color: '#1035E4'
          }, {
            from: 65,
            to: 67.5,
            color: '#0F31D1'
          }, {
            from: 67.5,
            to: 70,
            color: '#0E2DBE'
          }, {
            from: 70,
            to: 72.5,
            color: '#0D27AB'
          }, {
            from: 72.5,
            to: 75,
            color: '#0A2399'
          }, {
            from: 75,
            to: 77.5,
            color: '#FFC247'
          }, {
            from: 77.5,
            to: 80,
            color: '#FFB41F'
          }, {
            from: 80,
            to: 82.5,
            color: '#FFAD0B'
          }, {
            from: 82.5,
            to: 85,
            color: '#F5A300'
          }, {
            from: 85,
            to: 87.5,
            color: '#E19600'
          }, {
            from: 87.5,
            to: 90,
            color: '#CD8800'
          }, {
            from: 90,
            to: 92.5,
            color: '#B87B01'
          }, {
            from: 92.5,
            to: 95,
            color: '#A36E00'
          }, {
            from: 95,
            to: 97.5,
            color: '#8F6000'
          }, {
            from: 97.5,
            to: 100,
            color: '#7A5200'
          }]
        }
      }
    }
  };
  const {
    series = []
  } = heatMap;
  return /*#__PURE__*/React.createElement(Chart, {
    style: {
      cursor: 'pointer'
    },
    options: options,
    series: series,
    type: "treemap",
    width: "100%",
    height: 250
  });
};

export default CustomTreemap;